export class TagilMatrixController {
  constructor(parent) {
    const { $store, mapgl } = parent;

    this.parent = parent;
    this.$store = $store;
    this.map = mapgl;
  }

  toggleItems() {
    if (this.parent.isTagilMatrixActive) this.addItems();
    else this.removeItems();
  }

  addItems() {
    this.map.addSource("tagil_matrix", {
      type: "geojson",
      data: this.parent.tagilMatrixData
    });
    const expressions = this.getExpressions();

    this.map.addLayer({
      id: "tagil_matrix_lines",
      source: "tagil_matrix",
      type: "line",
      paint: {
        "line-width": 1.5,
        "line-offset": 3,
        "line-color": expressions
      }
    });
  }

  getExpressions() {
    const { min, max } = this.$store.state.situationCenter.tagilMatrix;
    const diff = max - min;
    const step = diff ? diff / 6 : 0.1;
    const colors = [
      "#3288bd",
      "#99d594",
      "#e6f598",
      "#ffffbf",
      "#fee08b",
      "#fc8d59"
    ];
    const values = [];
    colors.forEach((e, i) => {
      values.push(...[min + step * i, e]);
    });

    const expressions = [
      "interpolate",
      ["linear"],
      ["get", "value"],
      ...values
    ];

    return expressions;
  }

  removeItems() {
    // remove layers and sources
    if (this.map.getLayer("tagil_matrix_lines"))
      this.map.removeLayer("tagil_matrix_lines");
    if (this.map.getSource("tagil_matrix"))
      this.map.removeSource("tagil_matrix");
  }
}
